import { render, staticRenderFns } from "./contentRecord.vue?vue&type=template&id=5d3b06c2&scoped=true"
import script from "./contentRecord.vue?vue&type=script&lang=js"
export * from "./contentRecord.vue?vue&type=script&lang=js"
import style0 from "./contentRecord.vue?vue&type=style&index=0&id=5d3b06c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3b06c2",
  null
  
)

export default component.exports